import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { DispatchAndSupperAdminPrivilege } from "models/account";
import { RouteName } from "constants/route";

export default function DispatchAndSuperAdminGuard() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return <Navigate to={RouteName.LOGIN} />;
    
    const role = (jwtDecode(token) as any).role;
    if (DispatchAndSupperAdminPrivilege.includes(role)) return <Outlet />;
    else return <Navigate to={RouteName.LOGIN} />;
  } catch (error) {
    console.error("Error decoding token in DispatchAndSuperAdminGuard:", error);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    return <Navigate to={RouteName.LOGIN} />;
  }
}
